module.exports = __webpack_public_path__ + "static/media/Avenir-Book-01.995b34ab.ttf";